<app-header [showFindParking]="false"></app-header>

<div class="jumbotron jumbotron-fluid">
    <div class="jumbotron-inner">
        <div class="container-fluid flex-item mx-2 mx-md-5" [routerLink]="['/map-search']">
            <div class="row">
                <div class="col-12 col-sm-8 col-md-8 col-lg-6 col-xl-5 col-xxl-3 mx-2 mx-md-5">
                    <h1 class="hero-header text-light">Find Monthly Parking</h1>
                    <div class="text-light">
                        <div class="mb-3">
                            <b class="text-light">South Africa’s Leading Parking Marketplace</b>
                        </div>
                        Discover dedicated, tech-driven monthly parking solutions with ParkUpp, South Africa’s leading parking marketplace. Connecting property owners with parkers, we maximize
                        convenience and efficiency. Find your space today.
                    </div>
                    <br />
                    <a [routerLink]="['/map-search']" class="btn btn-primary main-button mt-3" routerLinkActive="active">
                        <div class="line-1">Click Here to Find Parking</div>
                        <div class="line-2">Book your dedicated monthly parking bay</div>
                    </a>
                    &nbsp; &nbsp; &nbsp;
                </div>
            </div>

            <!--            <app-ticker-tape class="ticker-tape"></app-ticker-tape>-->
        </div>
    </div>
</div>

<!-- <div class="container-fluid p-0 customer-logos bg-grey">
    <div class="row">
        <div class="col-6 col-md-2 text-center d-flex flex-column justify-content-center align-items-center p-4">
            <h5 class="fw-bold">TRUSTED BY</h5>
        </div>
        <ng-container *ngFor="let logo of customerLogos">
            <div class="col-6 col-md-2 text-center d-flex flex-column justify-content-center align-items-center p-4">
                <img [alt]="logo.alt" [src]="logo.src" />
            </div>
        </ng-container>
    </div>
</div> -->

<div class="container-fluid p-0 customer-logos bg-grey">
    <div class="row">
        <app-logo-slider></app-logo-slider>
    </div>
</div>

<div class="container py-5 my-md-5 px-4 text-center text-sm-start">
    <div class="row">
        <div class="col-sm-6 col-md-4">
            <h1>How Does It Work?</h1>
            <p>Find your dedicated parking in 3 easy steps!</p>
        </div>
        <div class="col-12 col-md-8">
            <div class="row mb-3">
                <div class="col-1">
                    <div class="fa-3x d-flex position-relative location-marker">
                        <i class="fas fa-map-marker text-primary position-absolute translate-middle"></i>
                        <h5 class="marker-text position-absolute translate-middle">1</h5>
                    </div>
                </div>
                <div class="col-11">
                    <h3 class="text-primary">Create A Profile</h3>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-12">You can either create a profile here or when booking your bay below. Add your vehicle and payment info.</div>
            </div>

            <div class="row mb-3">
                <div class="col-1">
                    <div class="fa-3x d-flex position-relative location-marker">
                        <i class="fas fa-map-marker text-primary position-absolute translate-middle"></i>
                        <h5 class="marker-text position-absolute translate-middle">2</h5>
                    </div>
                </div>
                <div class="col-11">
                    <h3 class="text-primary">Book Your Bay</h3>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-12">Fill in how many bays you need and the duration required. Submit your request.</div>
            </div>

            <div class="row mb-3">
                <div class="col-1">
                    <div class="fa-3x d-flex position-relative location-marker">
                        <i class="fas fa-map-marker text-primary position-absolute translate-middle"></i>
                        <h5 class="marker-text position-absolute translate-middle">3</h5>
                    </div>
                </div>
                <div class="col-11">
                    <h3 class="text-primary">Email Confirmation</h3>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-12">You’ll hear within 24 hours whether your request has been approved via email.</div>
            </div>

            <br /><br />
            <a [routerLink]="['/map-search']" class="text-black btn btn-primary mt-3" routerLinkActive="active"> Find Parking </a>&nbsp;
            <a [routerLink]="['/contact']" class="text-black btn btn-outline-primary mt-3" routerLinkActive="active"> Get In Touch </a>
        </div>
    </div>
</div>

<div class="container-fluid py-md-5 bg-dark-blue">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-4 mt-4 mt-lg-0 py-5 px-5 text-center">
                <img src="/assets/images/home/icon-cost.svg" />
                <h4 class="text-primary mb-3 mt-4">Cost-Effective</h4>
                <div class="text-light">ParkUpp always works out to be cheaper than the alternative of daily parking!</div>
            </div>

            <div class="col-12 col-lg-4 mt-4 mt-lg-0 py-5 px-5 text-center">
                <img src="/assets/images/home/icon-dedicated.svg" />
                <h4 class="text-primary mb-3 mt-4">Dedicated</h4>
                <div class="text-light">Save yourself the time and stress of having to look for a different bay each day.</div>
            </div>

            <div class="col-12 col-lg-4 mt-4 mt-lg-0 py-5 px-5 text-center">
                <img src="/assets/images/home/icon-hassle.svg" />
                <h4 class="text-primary mb-3 mt-4">Hassle-Free</h4>
                <div class="text-light">No lengthy contract negotiations with landlords. We do that for you!</div>
            </div>
        </div>
    </div>
</div>

<!--<div class="container-fluid p-0">-->
<!--    &lt;!&ndash; Logo ticker &ndash;&gt;-->
<!--&lt;!&ndash;    <div class="elfsight-app-076e0721-fd2c-4737-bfab-63f02b4a1208"></div>&ndash;&gt;-->
<!--</div>-->

<div class="container-fluid my-5">
    <div class="text-center pt-5">
        <h1 class="">Our Offerings</h1>
    </div>
    <div class="row">
        <div class="col-12">
            <div class="container mt-5 px-0">
                <div class="row justify-content-center">
                    <div class="col-md-4">
                        <div (click)="selectParkingType(parkingTypes.STANDARD)" class="card hover-card w-100 mb-3 m-md-3 rounded-3">
                            <div class="mask"><i class="arrow fas fa-angle-right"></i></div>
                            <img alt="" class="card-img-top img-fluid" src="assets/images/parking/parking-monthly.png" />
                            <div class="card-body">
                                <h4 class="py-2"><span class="header-part-light">ParkUpp</span>&nbsp;<span class="header-part-bold">Monthly</span></h4>
                                <div class="card-subtitle">Find and book monthly parking for living or work. Single and bulk bookings available for you or your team. <br /><br /></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div (click)="selectParkingType(parkingTypes.PARKING_COLLECTOR)" class="card hover-card w-100 mb-3 m-md-3 rounded-3">
                            <div class="mask"><i class="arrow fas fa-angle-right"></i></div>

                            <img alt="" class="card-img-top img-fluid" src="assets/images/parking/parking-collector.png" />

                            <div class="card-body">
                                <h4 class="py-2"><span class="header-part-light">ParkUpp</span>&nbsp;<span class="header-part-bold">Collector</span></h4>
                                <div class="card-subtitle">Park alongside like minded car collectors in our community basements.</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div (click)="selectParkingType(parkingTypes.FLEX)" class="card hover-card w-100 mb-3 m-md-3 rounded-3">
                            <div class="mask"><i class="arrow fas fa-angle-right"></i></div>
                            <img alt="" class="card-img-top img-fluid" src="assets/images/parking/parking-flex.png" />

                            <div class="card-body fixed-height">
                                <h4 class="py-2"><span class="header-part-light">ParkUpp</span>&nbsp;<span class="header-part-bold">Flex</span></h4>
                                <div class="card-subtitle">
                                    Discounted parking bays available for 1 month at a time. <br />
                                    <br />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-testimonials-block [header]="'Book With Confidence'"></app-testimonials-block>

<section class="py-md-5" id="news">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-lg-12">
                <br />
                <h1 class="text-center"><span class="header-part-bold">ParkUpp</span>&nbsp;<span class="header-part-light">News</span></h1>
                <br />
            </div>
        </div>
        <div class="row my-md-5">
            <div (click)="goToBlogPage(blog)" *ngFor="let blog of blogs" class="blog-clickable col-lg-4 mt-4 mt-lg-0 aos-init aos-animate px-3" data-aos="fade-up" data-aos-delay="600">
                <div class="card h-100 hover-card">
                    <div class="mask"><i class="arrow fas fa-angle-right"></i></div>
                    <img *ngIf="blog.blogImage" alt="" class="img-fluid rounded" src="{{ blog.blogImage.largeUrl }}" />
                    <div class="card-body">
                        <h5 class="mt-4 mb-2">{{ blog.title }}</h5>
                        <p class="blog-summary">{{ GlobalService.stripHtml(blog.body | truncate: [180, '...']) }}</p>
                        <br />
                        <a class="text-decoration-underline">Read More</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="text-center">
            <a [routerLink]="['/news']" class="btn btn-primary mt-3" routerLinkActive="active"> More news </a>
        </div>
    </div>
    <br />
    <br />
</section>

<!--<div class="row">-->
<!--    <div class="col-lg-12">-->
<!--        <br />-->
<!--    </div>-->
<!--</div>-->
<!--<div class="elfsight-app-b17c18b8-e19a-45ef-81b1-d0d44829c608"></div>-->

<!--<section id="testimonials" class=" mt-5 py-5">-->
<!--    <div class="container aos-init aos-animate" data-aos="fade-up">-->
<!--        &lt;!&ndash; Reviews &ndash;&gt;-->
<!--        <div class="elfsight-app-94161f56-18d6-464f-8eb9-9ebb9aa1d9a6"></div>-->
<!--    </div>-->
<!--</section>-->

<!-- Reviews floating -->
<!--<div class="elfsight-app-6b35f4eb-7c22-4e43-bcde-321b9da85852"></div>-->

<app-footer></app-footer>
